// 創作記錄翻譯

export const creationRecord = {
    title: '我的創作',
    description: '查看和管理您所有的AI生成創作',
    loading: '正在載入您的創作...',
    all: '全部',
    completed: '已完成',
    processing: '生成中',
    filterAll: '全部',
    filterImages: '圖片',
    filterVideos: '影片',
    filterAudio: '音頻',
    view: '查看',
    download: '下載',
    delete: '刪除',
    reEdit: '重新編輯',
    share: '分享',
    shareToX: '分享到 X',
    shareToFacebook: '分享到 Facebook',
    enterShareText: '輸入分享文案',
    useTemplate: '使用模板文案',
    templateShareText: '2025年最强AI内容工具没有之一！{brand} 统一风格 + 批量生成，自媒体人直接升天！速来！',
    credits: '積分',
    images: '圖片',
    noPreview: '無預覽',
    confirmDelete: '確定要刪除這個創作記錄嗎？',
    recordCard: {
      createdAt: '創建於',
      downloadOriginal: '下載原始檔案',
      downloadProcessed: '下載處理後檔案',
      viewDetails: '查看詳情'
    },
    emptyState: {
      noRecordsFound: '未找到記錄',
      noRecordsDescription: '您還沒有創建任何內容，或沒有符合篩選條件的記錄。',
      startCreating: '開始創作'
    },
    creationThumbnail: '創作縮略圖',
    noRecordsFound: '未找到記錄',
    noRecordsDescription: '您還沒有創建任何內容，或沒有符合篩選條件的記錄。',
    startCreating: '開始創作',
    types: {
      faceSwap: '捏脸',
      logoGeneration: 'Logo生成',
      idPhotoGeneration: '證件照生成',
      professionalPortrait: '專業肖像',
      popArtPortrait: '波普藝術肖像',
      animeStyle: '動漫風格',
      oilPainting: '油畫風格',
      watercolor: '水彩風格',
      sketchStyle: '素描風格',
      cyberpunk: '賽博朋克',
      restoredImage: '圖像修復',
      TEXT_TO_IMAGE: '文生圖',
      IMAGE_TO_IMAGE: '圖生圖',
      TEXT_TO_VIDEO: '文字轉影片',
      IMAGE_TO_VIDEO: '圖片轉影片',
      REFERENCE_IMAGE_TO_VIDEO: '參考圖轉影片',
      KEY_IMAGE_TO_VIDEO: '關鍵幀生成影片',
      TEXT_TO_AUDIO: '文生音頻',
      IMAGE_TO_AUDIO: '圖生音頻',
      LYRICS_GENERATION: '歌詞生成'
    }
  };
